import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// toast.configure();

export const setToast = (type, data) => {
  let message = data;
  if (typeof data === "object" && data !== null) {
    message = data.response?.data?.message || data.message || "Something went wrong!";
  }

  return toast(message, {
    type: type,
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    rtl: false,
  });
};
